import { FC } from "react";
import * as Styled from "./overviewComponents";
import Image from "next/image";

interface ImgCardProps {
  cardPath: string;
  active?: boolean;
  size?: string;
  className?: string;
  variant?: any;
}

export const ImgCard: FC<ImgCardProps> = ({ cardPath, active, size }) => {
  return (
    <Styled.ImgCard
      size={size}
      active={active}
      src={cardPath}
      alt="image-card-cellect"
    />
  );
};
